import { useState } from 'react';
import { CiCircleRemove } from 'react-icons/ci';
import { FaRegEdit } from 'react-icons/fa';
import { IoIosClose } from "react-icons/io";
import { RiErrorWarningLine } from "react-icons/ri";
import { Link } from 'react-router-dom';
import "./Request.scss";
import Replay from '../Replay/Replay';

const requestsData = [
  {
    id: 1,
    title: "Request",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus mollitia cum animi dolor alias!",
    date: "Feb 1 [4:30 PM]",
  },
    {
    id: 1,
    title: "Request",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus mollitia cum animi dolor alias!",
    date: "Feb 1 [4:30 PM]",
  },
    {
    id: 1,
    title: "Request",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus mollitia cum animi dolor alias!",
    date: "Feb 1 [4:30 PM]",
  },
    {
    id: 1,
    title: "Request",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus mollitia cum animi dolor alias!",
    date: "Feb 1 [4:30 PM]",
  },
    {
    id: 1,
    title: "Request",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus mollitia cum animi dolor alias!",
    date: "Feb 1 [4:30 PM]",
  }
];

export default function Request() {
  const [open, setOpen] = useState(false);

  return (
    <div className="request-page p-3">
     
      {open && (
        <div className="replay-overlay">
          <div className="replay-modal">
            <Replay />
            <button className="close-modal" onClick={() => setOpen(false)}>×</button>
          </div>
        </div>
      )}

      <div className="headerr">
       <div className="stock-filters">
        <Link to="/dashboard/HelpCenter"><button className="stock-filter ">Help</button></Link>
     <Link to="/dashboard/SupportFaqs"><button className="stock-filter ">FAQs</button></Link> 
      <Link to="/dashboard/PrivacyPolicy"><button className="stock-filter ">Privacy</button></Link>
       <Link to="/dashboard/Request"><button className="stock-filter actives">Request</button></Link>
    
       </div>
     
       <div className="search-wrapperr">
         <input
           type="text"
           placeholder="Search by order id"
           className="stock-search"
         />
         <i className="fa-solid fa-magnifying-glass search-icon"></i>
       </div>
     
       <div className="stock-header">
         <div className="stock-actions">
           <Link to="/dashboard/AddNewProductss">
                 <button className="stock-btn blue">Edit Helpnote</button>
           </Link>
     <Link to="/dashboard/AddNewservieses">
      <button className="stock-btn">Add New Helpnote</button>
     </Link>
          
         </div>
       </div>
     </div>

      {requestsData.map((request) => (
        <div key={request.id} className="request-content">
          <div className="request-header">
            <div className="d-flex align-items-center gap-3">
              <RiErrorWarningLine className="icon success" />
              <span className="title">{request.title}</span>
            </div>
            <IoIosClose className="icon close" />
          </div>

          <p className="request-description">{request.description}</p>

          <div className="d-flex align-items-center justify-content-between">
            <div className="faq-actions">
              <button className="edit">Closed <FaRegEdit /></button>
              <button className="remove" onClick={() => setOpen(true)}>Reply <CiCircleRemove /></button>
            </div>
            <p>{request.date}</p>
          </div>
        </div>
      ))}

      <div className="table-footer">
        <div className="showing-info">Showing 17 of 100</div>
        <div className="pagination">
          <button className="active">1</button>
          <button>2</button>
          <button>3</button>
          <button>4</button>
          <button>5</button>
          <button>Next</button>
        </div>
      </div>
    </div>
  );
}
